import { render, staticRenderFns } from "./PrepaidFee.vue?vue&type=template&id=fce22db8&scoped=true&"
import script from "./PrepaidFee.vue?vue&type=script&lang=js&"
export * from "./PrepaidFee.vue?vue&type=script&lang=js&"
import style0 from "./PrepaidFee.vue?vue&type=style&index=0&id=fce22db8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce22db8",
  null
  
)

export default component.exports